export default __webpack_public_path__ + "static/studio-slider-26-6e64c3a7f857eabc0cbcd4c67195d124.png";